// removed by extract-text-webpack-plugin
module.exports = {"container":"_3DGY10aSFALSdc-RP9ubRB","title":"_1ygYj10wfPISvuuugXbuxF"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/Viewer/styles.css
// module id = 3170
// module chunks = 0